namespace GeniuzPOS.InventoryReport {
    export interface IcReport02_VForm {
    }

    export class IcReport02_VForm extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport02_V';
    }
}
